/*sharing-tsconfigjson*/
/*use-a-base-tsconfig-file*/
/*creating-the-rest-of-the-package*/
/*building-a-typescript-package*/
/*using-the-configuration-package*/
/*creating-entrypoints-to-the-package*/
/*linting-your-codebase*/
/*best-practices*/
/*use-tsc-to-compile-your-packages*/
/*enable-go-to-definition-across-package-boundaries*/
/*just-in-time-packages*/
/*compiled-packages*/
/*use-nodejs-subpath-imports-instead-of-typescript-compiler-paths*/
/*just-in-time-packages-1*/
/*compiled-packages-1*/
/*you-likely-dont-need-a-tsconfigjson-file-in-the-root-of-your-project*/
/*you-likely-dont-need-typescript-project-references*/
/*limitations*/
/*your-editor-wont-use-a-packages-typescript-version*/
import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
export let lastModified = undefined;
export let frontmatter = {
  "title": "TypeScript",
  "description": "学习如何在 Monorepo 中使用 TypeScript。"
};
export let structuredData = {
  "contents": [{
    "heading": "",
    "content": "TypeScript 是 monorepos 中的一个优秀工具，允许团队安全地将类型添加到他们的 JavaScript 代码中。虽然设置起来有些复杂，但本指南将引导你完成大多数用例中 TypeScript 设置的重要部分。"
  }, {
    "heading": "",
    "content": "¥TypeScript is an excellent tool in monorepos, allowing teams to safely add types to their JavaScript code. While there is some complexity to getting set up, this guide will walk you through the important parts of a TypeScript setup for most use cases."
  }, {
    "heading": "",
    "content": "共享 TypeScript 配置"
  }, {
    "heading": "",
    "content": "¥Sharing TypeScript configuration"
  }, {
    "heading": "",
    "content": "构建 TypeScript 软件包"
  }, {
    "heading": "",
    "content": "¥Building a TypeScript package"
  }, {
    "heading": "",
    "content": "加快整个工作区的类型检查速度"
  }, {
    "heading": "",
    "content": "¥Making type checking faster across your workspace"
  }, {
    "heading": "",
    "content": "本指南假设你正在使用最新版本的 TypeScript，并使用一些仅在这些版本中可用的功能。如果你无法使用这些版本的功能，你可能需要调整此页面上的指南。"
  }, {
    "heading": "",
    "content": "¥This guide assumes you are using a recent version of TypeScript and uses some\nfeatures that are only available in those versions. You may need to adjust the\nguidance on this page if you are unable to features from those versions."
  }, {
    "heading": "共享-tsconfigjson-sharing-tsconfigjson",
    "content": "¥Sharing tsconfig.json"
  }, {
    "heading": "共享-tsconfigjson-sharing-tsconfigjson",
    "content": "你希望在 TypeScript 配置中建立一致性，以便你的整个代码库可以使用良好的默认值，并且你的其他开发者在工作区中编写代码时能够了解预期的内容。"
  }, {
    "heading": "共享-tsconfigjson-sharing-tsconfigjson",
    "content": "¥You want to build consistency into your TypeScript configurations so that your entire repo can use great defaults and your fellow developers can know what to expect when writing code in the Workspace."
  }, {
    "heading": "共享-tsconfigjson-sharing-tsconfigjson",
    "content": "TypeScript 的 tsconfig.json 设置了 TypeScript 编译器的配置，并提供了一个 extends 键，你可以使用它在整个工作区中共享配置。"
  }, {
    "heading": "共享-tsconfigjson-sharing-tsconfigjson",
    "content": "¥TypeScript's tsconfig.json sets the configuration for the TypeScript compiler and features an extends key that you'll use to share configuration across your workspace."
  }, {
    "heading": "共享-tsconfigjson-sharing-tsconfigjson",
    "content": "本指南将以 create-turbo 为例。"
  }, {
    "heading": "共享-tsconfigjson-sharing-tsconfigjson",
    "content": "¥This guide will use create-turbo as an example."
  }, {
    "heading": "使用基础-tsconfig-文件-use-a-base-tsconfig-file",
    "content": "¥Use a base tsconfig file"
  }, {
    "heading": "使用基础-tsconfig-文件-use-a-base-tsconfig-file",
    "content": "在 packages/typescript-config 文件中，有几个 json 文件，它们代表了你可能希望在各个包中配置 TypeScript 的不同方式。base.json 文件由工作区中的所有其他 tsconfig.json 文件扩展，如下所示："
  }, {
    "heading": "使用基础-tsconfig-文件-use-a-base-tsconfig-file",
    "content": "¥Inside packages/typescript-config, you have a few json files which represent different ways you might want to configure TypeScript in various packages. The base.json file is extended by every other tsconfig.json in the workspace and looks like this:"
  }, {
    "heading": "使用基础-tsconfig-文件-use-a-base-tsconfig-file",
    "content": "tsconfig 选项参考"
  }, {
    "heading": "使用基础-tsconfig-文件-use-a-base-tsconfig-file",
    "content": "¥tsconfig options reference"
  }, {
    "heading": "创建其余部分包-creating-the-rest-of-the-package",
    "content": "¥Creating the rest of the package"
  }, {
    "heading": "创建其余部分包-creating-the-rest-of-the-package",
    "content": "此包中的其他 tsconfig 文件使用 extends 键，以基本配置启动，并针对特定类型的项目进行自定义，例如 Next.js (nextjs.json) 和 React 库 (react-library.json)。"
  }, {
    "heading": "创建其余部分包-creating-the-rest-of-the-package",
    "content": "¥The other tsconfig files in this package use the extends key to start with the base configuration and customize for specific types of projects, like for Next.js (nextjs.json) and a React library (react-library.json)."
  }, {
    "heading": "创建其余部分包-creating-the-rest-of-the-package",
    "content": "在 package.json 文件中，为包命名，以便可以在工作区的其余部分引用它："
  }, {
    "heading": "创建其余部分包-creating-the-rest-of-the-package",
    "content": "¥Inside package.json, name the package so it can be referenced in the rest of the Workspace:"
  }, {
    "heading": "构建-typescript-软件包-building-a-typescript-package",
    "content": "¥Building a TypeScript package"
  }, {
    "heading": "使用配置包-using-the-configuration-package",
    "content": "¥Using the configuration package"
  }, {
    "heading": "使用配置包-using-the-configuration-package",
    "content": "首先，将 @repo/typescript-config 包安装到你的包中："
  }, {
    "heading": "使用配置包-using-the-configuration-package",
    "content": "¥First, install the @repo/typescript-config package into your package:"
  }, {
    "heading": "使用配置包-using-the-configuration-package",
    "content": "然后，从 @repo/typescript-config 包中扩展包的 tsconfig.json。在此示例中，web 包是一个 Next.js 应用："
  }, {
    "heading": "使用配置包-using-the-configuration-package",
    "content": "¥Then, extend the tsconfig.json for the package from the @repo/typescript-config package. In this example, the web package is a Next.js application:"
  }, {
    "heading": "创建包的入口点-creating-entrypoints-to-the-package",
    "content": "¥Creating entrypoints to the package"
  }, {
    "heading": "创建包的入口点-creating-entrypoints-to-the-package",
    "content": "首先，确保你的代码使用 tsc 编译，这样就会有一个 dist 目录。你需要一个 build 脚本和一个 dev 脚本："
  }, {
    "heading": "创建包的入口点-creating-entrypoints-to-the-package",
    "content": "¥First, make sure your code gets compiled with tsc so there will be a dist directory. You'll need a build script as well as a dev script:"
  }, {
    "heading": "创建包的入口点-creating-entrypoints-to-the-package",
    "content": "然后，在 package.json 中为你的包设置入口点，以便其他包可以使用编译后的代码："
  }, {
    "heading": "创建包的入口点-creating-entrypoints-to-the-package",
    "content": "¥Then, set up the entrypoints for your package in package.json so that other packages can use the compiled code:"
  }, {
    "heading": "创建包的入口点-creating-entrypoints-to-the-package",
    "content": "以这种方式设置 exports 有几个优点："
  }, {
    "heading": "创建包的入口点-creating-entrypoints-to-the-package",
    "content": "¥Setting up exports this way has several advantages:"
  }, {
    "heading": "创建包的入口点-creating-entrypoints-to-the-package",
    "content": "使用 types 字段允许 tsserver 使用 src 中的代码作为代码类型的真实来源。你的编辑器将始终使用你代码中的最新接口保持更新。"
  }, {
    "heading": "创建包的入口点-creating-entrypoints-to-the-package",
    "content": "¥Using the types field allows tsserver to use the code in src as the source of truth for your code's types. Your editor will always be up-to-date with the latest interfaces from your code."
  }, {
    "heading": "创建包的入口点-creating-entrypoints-to-the-package",
    "content": "你可以快速向包中添加新的入口点，而无需创建 危险的桶文件。"
  }, {
    "heading": "创建包的入口点-creating-entrypoints-to-the-package",
    "content": "¥You can quickly add new entrypoints to your package without creating dangerous barrel files."
  }, {
    "heading": "创建包的入口点-creating-entrypoints-to-the-package",
    "content": "你将在编辑器中收到跨包导入的自动导入建议。"
  }, {
    "heading": "创建包的入口点-creating-entrypoints-to-the-package",
    "content": "¥You'll receive auto-importing suggestions for your imports across package boundaries in your editor."
  }, {
    "heading": "创建包的入口点-creating-entrypoints-to-the-package",
    "content": "如果你要发布软件包，则无法在 types 中使用对源代码的引用，因为只有编译后的代码才会发布到 npm。你需要生成并引用声明文件和源映射。"
  }, {
    "heading": "创建包的入口点-creating-entrypoints-to-the-package",
    "content": "¥If you're publishing the package, you cannot use references to source code in\ntypes since only the compiled code will be published to npm. You'll need to\ngenerate and reference declaration files and source maps."
  }, {
    "heading": "代码库的-linting-linting-your-codebase",
    "content": "¥Linting your codebase"
  }, {
    "heading": "代码库的-linting-linting-your-codebase",
    "content": "要将 TypeScript 用作 linter，你可以使用 Turborepo 的缓存和并行化功能快速检查整个工作区的类型。"
  }, {
    "heading": "代码库的-linting-linting-your-codebase",
    "content": "¥To use TypeScript as a linter, you can check the types across your workspace fast using Turborepo's caching and parallelization."
  }, {
    "heading": "代码库的-linting-linting-your-codebase",
    "content": "首先，向任何你想要检查类型的包添加一个 check-types 脚本："
  }, {
    "heading": "代码库的-linting-linting-your-codebase",
    "content": "¥First, add a check-types script to any package that you want to check the types for:"
  }, {
    "heading": "代码库的-linting-linting-your-codebase",
    "content": "然后，在 turbo.json 中创建一个 check-types 任务。从 配置任务指南 开始，我们可以使用 Transit Node 使任务并行运行，同时尊重其他软件包的源代码更改："
  }, {
    "heading": "代码库的-linting-linting-your-codebase",
    "content": "¥Then, create a check-types task in turbo.json. From the Configuring tasks guide, we can make the task run in parallel while respecting source code changes from other packages using a Transit Node:"
  }, {
    "heading": "代码库的-linting-linting-your-codebase",
    "content": "然后，使用 turbo check-types 运行你的任务。"
  }, {
    "heading": "代码库的-linting-linting-your-codebase",
    "content": "¥Then, run your task using turbo check-types."
  }, {
    "heading": "最佳实践-best-practices",
    "content": "¥Best practices"
  }, {
    "heading": "使用-tsc-编译你的软件包-use-tsc-to-compile-your-packages",
    "content": "¥Use tsc to compile your packages"
  }, {
    "heading": "使用-tsc-编译你的软件包-use-tsc-to-compile-your-packages",
    "content": "对于 内部软件包，我们建议你尽可能使用 tsc 来编译 TypeScript 库。虽然你可以使用打包器，但它不是必需的，而且会增加构建过程的复杂性。此外，打包库可能会在代码到达应用的打包器之前对其进行破坏，从而导致难以调试的问题。"
  }, {
    "heading": "使用-tsc-编译你的软件包-use-tsc-to-compile-your-packages",
    "content": "¥For Internal Packages, we recommend that you use tsc to compile your TypeScript libraries whenever possible. While you can use a bundler, it's not necessary and adds extra complexity to your build process. Additionally, bundling a library can mangle the code before it makes it to your applications' bundlers, causing hard to debug issues."
  }, {
    "heading": "启用跨包边界的跳转定义-enable-go-to-definition-across-package-boundaries",
    "content": "¥Enable go-to-definition across package boundaries"
  }, {
    "heading": "启用跨包边界的跳转定义-enable-go-to-definition-across-package-boundaries",
    "content": "\"跳转至定义\" 是一项编辑器功能，可通过单击或热键快速导航到符号（如变量或函数）的原始声明或定义。正确配置 TypeScript 后，你可以轻松在 内部软件包 中导航。"
  }, {
    "heading": "启用跨包边界的跳转定义-enable-go-to-definition-across-package-boundaries",
    "content": "¥\"Go-to-definition\" is an editor feature for quickly navigating to the original declaration or definition of a symbol (like a variable or function) with a click or hotkey. Once TypeScript is configured correctly, you can navigate across Internal Packages with ease."
  }, {
    "heading": "即时软件包-just-in-time-packages",
    "content": "¥Just-in-Time Packages"
  }, {
    "heading": "即时软件包-just-in-time-packages",
    "content": "从 即时软件包 导出将自动转到原始 TypeScript 源代码。跳转定义功能将按预期工作。"
  }, {
    "heading": "即时软件包-just-in-time-packages",
    "content": "¥Exports from Just-in-Time Packages will automatically bring you to the original TypeScript source code. Go-to-definition will work as expected."
  }, {
    "heading": "已编译的软件包-compiled-packages",
    "content": "¥Compiled Packages"
  }, {
    "heading": "已编译的软件包-compiled-packages",
    "content": "从 已编译的软件包 导出需要使用 declaration 和 declarationMap 配置才能实现跳转定义功能。为包启用这两个配置后，使用 tsc 编译包，然后打开输出目录以查找声明文件和源映射。"
  }, {
    "heading": "已编译的软件包-compiled-packages",
    "content": "¥Exports from Compiled Packages require the use of declaration and declarationMap configurations for go-to-definition to work. After you've enabled these two configurations for the package, compile the package with tsc, and open the output directory to find declaration files and source maps."
  }, {
    "heading": "已编译的软件包-compiled-packages",
    "content": "有了这两个文件，你的编辑器现在将导航到原始源代码。"
  }, {
    "heading": "已编译的软件包-compiled-packages",
    "content": "¥With these two files in place, your editor will now navigate to the original source code."
  }, {
    "heading": "使用-nodejs-子路径导入而不是-typescript-编译器-paths-use-nodejs-subpath-imports-instead-of-typescript-compiler-paths",
    "content": "¥Use Node.js subpath imports instead of TypeScript compiler paths"
  }, {
    "heading": "使用-nodejs-子路径导入而不是-typescript-编译器-paths-use-nodejs-subpath-imports-instead-of-typescript-compiler-paths",
    "content": "可以使用 TypeScript 编译器的 paths 选项 在包中创建绝对导入，但使用 即时软件包 时，这些路径可能会导致编译失败。自 TypeScript 5.4 起，你可以使用 Node.js 子路径导入 来获得更强大的解决方案。"
  }, {
    "heading": "使用-nodejs-子路径导入而不是-typescript-编译器-paths-use-nodejs-subpath-imports-instead-of-typescript-compiler-paths",
    "content": "¥It's possible to create absolute imports in your packages using the TypeScript compiler's paths option, but these paths can cause failed compilation when using Just-in-Time Packages. As of TypeScript 5.4, you can use Node.js subpath imports instead for a more robust solution."
  }, {
    "heading": "即时软件包-just-in-time-packages-1",
    "content": "¥Just-in-Time Packages"
  }, {
    "heading": "即时软件包-just-in-time-packages-1",
    "content": "在 Just-in-Time 包 中，imports 必须以包中的源代码为目标，因为不会创建像 dist 这样的构建输出。"
  }, {
    "heading": "即时软件包-just-in-time-packages-1",
    "content": "¥In Just-in-Time packages, imports must target the source code in the package, since build outputs like dist won't be created."
  }, {
    "heading": "已编译的软件包-compiled-packages-1",
    "content": "¥Compiled Packages"
  }, {
    "heading": "已编译的软件包-compiled-packages-1",
    "content": "在 编译包 中，imports 以包的构建输出为目标。"
  }, {
    "heading": "已编译的软件包-compiled-packages-1",
    "content": "¥In Compiled packages, imports target the built outputs for the package."
  }, {
    "heading": "你可能不需要在项目根目录中放置-tsconfigjson-文件-you-likely-dont-need-a-tsconfigjson-file-in-the-root-of-your-project",
    "content": "¥You likely don't need a tsconfig.json file in the root of your project"
  }, {
    "heading": "你可能不需要在项目根目录中放置-tsconfigjson-文件-you-likely-dont-need-a-tsconfigjson-file-in-the-root-of-your-project",
    "content": "正如 构建仓库指南 中提到的，你需要将工具中的每个包视为独立的单元。这意味着每个包都应该有自己的 tsconfig.json 可供使用，而不是在项目根目录中引用 tsconfig.json。遵循此做法将使 Turborepo 更轻松地缓存你的类型检查任务，从而简化你的配置。"
  }, {
    "heading": "你可能不需要在项目根目录中放置-tsconfigjson-文件-you-likely-dont-need-a-tsconfigjson-file-in-the-root-of-your-project",
    "content": "¥As mentioned in the Structuring your repository guide, you want to treat each package in your tooling as its own unit. This means each package should have its own tsconfig.json to use instead of referencing a tsconfig.json in the root of your project. Following this practice will make it easier for Turborepo to cache your type checking tasks, simplifying your configuration."
  }, {
    "heading": "你可能不需要在项目根目录中放置-tsconfigjson-文件-you-likely-dont-need-a-tsconfigjson-file-in-the-root-of-your-project",
    "content": "唯一可能需要在工作区根目录中使用 tsconfig.json 的情况是，需要为不在包中的 TypeScript 文件设置配置。例如，如果你有一个用 TypeScript 编写的脚本需要从根目录运行，则该文件可能需要一个 tsconfig.json。"
  }, {
    "heading": "你可能不需要在项目根目录中放置-tsconfigjson-文件-you-likely-dont-need-a-tsconfigjson-file-in-the-root-of-your-project",
    "content": "¥The only case in which you may want to have a tsconfig.json in the Workspace root is to set configuration for TypeScript files that are not in packages. For example, if you have a script written with TypeScript that you need to run from the root, you may need a tsconfig.json for that file."
  }, {
    "heading": "你可能不需要在项目根目录中放置-tsconfigjson-文件-you-likely-dont-need-a-tsconfigjson-file-in-the-root-of-your-project",
    "content": "但是，我们不建议这样做，因为工作区根目录中的任何更改都会导致所有任务缓存丢失。相反，将这些脚本移动到代码库中的其他目录。"
  }, {
    "heading": "你可能不需要在项目根目录中放置-tsconfigjson-文件-you-likely-dont-need-a-tsconfigjson-file-in-the-root-of-your-project",
    "content": "¥However, this practice is also discouraged since any changes in the Workspace root will cause all tasks to miss cache. Instead, move those scripts to a different directory in the repository."
  }, {
    "heading": "你可能不需要-typescript-项目引用-you-likely-dont-need-typescript-project-references",
    "content": "¥You likely don't need TypeScript Project References"
  }, {
    "heading": "你可能不需要-typescript-项目引用-you-likely-dont-need-typescript-project-references",
    "content": "我们不建议使用 TypeScript 项目引用，因为它们会为你的工作区引入另一个配置点和另一个缓存层。这两种方式都可能在你的仓库中造成问题，而且几乎没有什么好处，所以我们建议在使用 Turborepo 时避免使用它们。"
  }, {
    "heading": "你可能不需要-typescript-项目引用-you-likely-dont-need-typescript-project-references",
    "content": "¥We don't recommend using TypeScript Project References as they introduce both another point of configuration as well as another caching layer to your workspace. Both of these can cause problems in your repository with little benefit, so we suggest avoiding them when using Turborepo."
  }, {
    "heading": "限制-limitations",
    "content": "¥Limitations"
  }, {
    "heading": "你的编辑器不会使用包的-typescript-版本-your-editor-wont-use-a-packages-typescript-version",
    "content": "¥Your editor won't use a package's TypeScript version"
  }, {
    "heading": "你的编辑器不会使用包的-typescript-版本-your-editor-wont-use-a-packages-typescript-version",
    "content": "tsserver 无法在你的代码编辑器中为不同的包使用不同的 TypeScript 版本。相反，它会发现一个特定的版本并在任何地方使用它。"
  }, {
    "heading": "你的编辑器不会使用包的-typescript-版本-your-editor-wont-use-a-packages-typescript-version",
    "content": "¥tsserver is not able to use different TypeScript versions for different packages in your code editor. Instead, it will discover a specific version and use that everywhere."
  }, {
    "heading": "你的编辑器不会使用包的-typescript-版本-your-editor-wont-use-a-packages-typescript-version",
    "content": "这可能会导致编辑器中显示的 linting 错误与你运行 tsc 脚本检查类型时显示的 linting 错误不同。如果这对你来说是一个问题，请考虑使用 保持 TypeScript 依赖在同一版本上。"
  }, {
    "heading": "你的编辑器不会使用包的-typescript-版本-your-editor-wont-use-a-packages-typescript-version",
    "content": "¥This can result in differences between the linting errors that show in your editor and when you run tsc scripts to check types. If this is an issue for you, consider keeping the TypeScript dependency on the same version."
  }],
  "headings": [{
    "id": "共享-tsconfigjson-sharing-tsconfigjson",
    "content": "共享 tsconfig.json /*sharing-tsconfigjson*/"
  }, {
    "id": "使用基础-tsconfig-文件-use-a-base-tsconfig-file",
    "content": "使用基础 tsconfig 文件 /*use-a-base-tsconfig-file*/"
  }, {
    "id": "创建其余部分包-creating-the-rest-of-the-package",
    "content": "创建其余部分包 /*creating-the-rest-of-the-package*/"
  }, {
    "id": "构建-typescript-软件包-building-a-typescript-package",
    "content": "构建 TypeScript 软件包 /*building-a-typescript-package*/"
  }, {
    "id": "使用配置包-using-the-configuration-package",
    "content": "使用配置包 /*using-the-configuration-package*/"
  }, {
    "id": "创建包的入口点-creating-entrypoints-to-the-package",
    "content": "创建包的入口点 /*creating-entrypoints-to-the-package*/"
  }, {
    "id": "代码库的-linting-linting-your-codebase",
    "content": "代码库的 Linting /*linting-your-codebase*/"
  }, {
    "id": "最佳实践-best-practices",
    "content": "最佳实践 /*best-practices*/"
  }, {
    "id": "使用-tsc-编译你的软件包-use-tsc-to-compile-your-packages",
    "content": "使用 tsc 编译你的软件包 /*use-tsc-to-compile-your-packages*/"
  }, {
    "id": "启用跨包边界的跳转定义-enable-go-to-definition-across-package-boundaries",
    "content": "启用跨包边界的跳转定义 /*enable-go-to-definition-across-package-boundaries*/"
  }, {
    "id": "即时软件包-just-in-time-packages",
    "content": "即时软件包 /*just-in-time-packages*/"
  }, {
    "id": "已编译的软件包-compiled-packages",
    "content": "已编译的软件包 /*compiled-packages*/"
  }, {
    "id": "使用-nodejs-子路径导入而不是-typescript-编译器-paths-use-nodejs-subpath-imports-instead-of-typescript-compiler-paths",
    "content": "使用 Node.js 子路径导入，而不是 TypeScript 编译器 paths /*use-nodejs-subpath-imports-instead-of-typescript-compiler-paths*/"
  }, {
    "id": "即时软件包-just-in-time-packages-1",
    "content": "即时软件包 /*just-in-time-packages-1*/"
  }, {
    "id": "已编译的软件包-compiled-packages-1",
    "content": "已编译的软件包 /*compiled-packages-1*/"
  }, {
    "id": "你可能不需要在项目根目录中放置-tsconfigjson-文件-you-likely-dont-need-a-tsconfigjson-file-in-the-root-of-your-project",
    "content": "你可能不需要在项目根目录中放置 tsconfig.json 文件 /*you-likely-dont-need-a-tsconfigjson-file-in-the-root-of-your-project*/"
  }, {
    "id": "你可能不需要-typescript-项目引用-you-likely-dont-need-typescript-project-references",
    "content": "你可能不需要 TypeScript 项目引用 /*you-likely-dont-need-typescript-project-references*/"
  }, {
    "id": "限制-limitations",
    "content": "限制 /*limitations*/"
  }, {
    "id": "你的编辑器不会使用包的-typescript-版本-your-editor-wont-use-a-packages-typescript-version",
    "content": "你的编辑器不会使用包的 TypeScript 版本 /*your-editor-wont-use-a-packages-typescript-version*/"
  }]
};
import {Callout} from '#components/callout';
import {File, Folder, Files} from '#components/files';
import {Tabs, Tab} from 'fumadocs-ui/components/tabs';
import {LinkToDocumentation} from '#components/link-to-documentation';
export const toc = [{
  depth: 2,
  url: "#共享-tsconfigjson-sharing-tsconfigjson",
  title: _jsxs(_Fragment, {
    children: ["共享 ", _jsx("code", {
      children: "tsconfig.json"
    }), " "]
  })
}, {
  depth: 3,
  url: "#使用基础-tsconfig-文件-use-a-base-tsconfig-file",
  title: _jsxs(_Fragment, {
    children: ["使用基础 ", _jsx("code", {
      children: "tsconfig"
    }), " 文件 "]
  })
}, {
  depth: 3,
  url: "#创建其余部分包-creating-the-rest-of-the-package",
  title: _jsx(_Fragment, {
    children: "创建其余部分包 "
  })
}, {
  depth: 2,
  url: "#构建-typescript-软件包-building-a-typescript-package",
  title: _jsx(_Fragment, {
    children: "构建 TypeScript 软件包 "
  })
}, {
  depth: 3,
  url: "#使用配置包-using-the-configuration-package",
  title: _jsx(_Fragment, {
    children: "使用配置包 "
  })
}, {
  depth: 3,
  url: "#创建包的入口点-creating-entrypoints-to-the-package",
  title: _jsx(_Fragment, {
    children: "创建包的入口点 "
  })
}, {
  depth: 2,
  url: "#代码库的-linting-linting-your-codebase",
  title: _jsx(_Fragment, {
    children: "代码库的 Linting "
  })
}, {
  depth: 2,
  url: "#最佳实践-best-practices",
  title: _jsx(_Fragment, {
    children: "最佳实践 "
  })
}, {
  depth: 3,
  url: "#使用-tsc-编译你的软件包-use-tsc-to-compile-your-packages",
  title: _jsxs(_Fragment, {
    children: ["使用 ", _jsx("code", {
      children: "tsc"
    }), " 编译你的软件包 "]
  })
}, {
  depth: 3,
  url: "#启用跨包边界的跳转定义-enable-go-to-definition-across-package-boundaries",
  title: _jsx(_Fragment, {
    children: "启用跨包边界的跳转定义 "
  })
}, {
  depth: 4,
  url: "#即时软件包-just-in-time-packages",
  title: _jsx(_Fragment, {
    children: "即时软件包 "
  })
}, {
  depth: 4,
  url: "#已编译的软件包-compiled-packages",
  title: _jsx(_Fragment, {
    children: "已编译的软件包 "
  })
}, {
  depth: 3,
  url: "#使用-nodejs-子路径导入而不是-typescript-编译器-paths-use-nodejs-subpath-imports-instead-of-typescript-compiler-paths",
  title: _jsxs(_Fragment, {
    children: ["使用 Node.js 子路径导入，而不是 TypeScript 编译器 ", _jsx("code", {
      children: "paths"
    }), " "]
  })
}, {
  depth: 4,
  url: "#即时软件包-just-in-time-packages-1",
  title: _jsx(_Fragment, {
    children: "即时软件包 "
  })
}, {
  depth: 4,
  url: "#已编译的软件包-compiled-packages-1",
  title: _jsx(_Fragment, {
    children: "已编译的软件包 "
  })
}, {
  depth: 3,
  url: "#你可能不需要在项目根目录中放置-tsconfigjson-文件-you-likely-dont-need-a-tsconfigjson-file-in-the-root-of-your-project",
  title: _jsxs(_Fragment, {
    children: ["你可能不需要在项目根目录中放置 ", _jsx("code", {
      children: "tsconfig.json"
    }), " 文件 "]
  })
}, {
  depth: 3,
  url: "#你可能不需要-typescript-项目引用-you-likely-dont-need-typescript-project-references",
  title: _jsx(_Fragment, {
    children: "你可能不需要 TypeScript 项目引用 "
  })
}, {
  depth: 2,
  url: "#限制-limitations",
  title: _jsx(_Fragment, {
    children: "限制 "
  })
}, {
  depth: 3,
  url: "#你的编辑器不会使用包的-typescript-版本-your-editor-wont-use-a-packages-typescript-version",
  title: _jsx(_Fragment, {
    children: "你的编辑器不会使用包的 TypeScript 版本 "
  })
}];
function _createMdxContent(props) {
  const _components = {
    a: "a",
    code: "code",
    h2: "h2",
    h3: "h3",
    h4: "h4",
    li: "li",
    p: "p",
    pre: "pre",
    span: "span",
    strong: "strong",
    ul: "ul",
    ...props.components
  };
  return _jsxs(_Fragment, {
    children: [_jsx(_components.p, {
      children: "TypeScript 是 monorepos 中的一个优秀工具，允许团队安全地将类型添加到他们的 JavaScript 代码中。虽然设置起来有些复杂，但本指南将引导你完成大多数用例中 TypeScript 设置的重要部分。"
    }), "\n", _jsx(_components.p, {
      children: "¥TypeScript is an excellent tool in monorepos, allowing teams to safely add types to their JavaScript code. While there is some complexity to getting set up, this guide will walk you through the important parts of a TypeScript setup for most use cases."
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: _jsx(_components.a, {
            href: "#sharing-tsconfigjson",
            children: "共享 TypeScript 配置"
          })
        }), "\n", _jsxs(_components.p, {
          children: ["¥", _jsx(_components.a, {
            href: "#sharing-tsconfigjson",
            children: "Sharing TypeScript configuration"
          })]
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: _jsx(_components.a, {
            href: "#building-a-typescript-package",
            children: "构建 TypeScript 软件包"
          })
        }), "\n", _jsxs(_components.p, {
          children: ["¥", _jsx(_components.a, {
            href: "#building-a-typescript-package",
            children: "Building a TypeScript package"
          })]
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: _jsx(_components.a, {
            href: "/docs/guides/tools/typescript#linting-your-codebase",
            children: "加快整个工作区的类型检查速度"
          })
        }), "\n", _jsxs(_components.p, {
          children: ["¥", _jsx(_components.a, {
            href: "/docs/guides/tools/typescript#linting-your-codebase",
            children: "Making type checking faster across your workspace"
          })]
        }), "\n"]
      }), "\n"]
    }), "\n", _jsxs(Callout, {
      type: "info",
      children: [_jsx(_components.p, {
        children: "本指南假设你正在使用最新版本的 TypeScript，并使用一些仅在这些版本中可用的功能。如果你无法使用这些版本的功能，你可能需要调整此页面上的指南。"
      }), _jsx(_components.p, {
        children: "¥This guide assumes you are using a recent version of TypeScript and uses some\nfeatures that are only available in those versions. You may need to adjust the\nguidance on this page if you are unable to features from those versions."
      })]
    }), "\n", _jsxs(_components.h2, {
      id: "共享-tsconfigjson-sharing-tsconfigjson",
      children: ["共享 ", _jsx(_components.code, {
        children: "tsconfig.json"
      }), " "]
    }), "\n", _jsxs(_components.p, {
      children: ["¥Sharing ", _jsx(_components.code, {
        children: "tsconfig.json"
      })]
    }), "\n", _jsx(_components.p, {
      children: "你希望在 TypeScript 配置中建立一致性，以便你的整个代码库可以使用良好的默认值，并且你的其他开发者在工作区中编写代码时能够了解预期的内容。"
    }), "\n", _jsx(_components.p, {
      children: "¥You want to build consistency into your TypeScript configurations so that your entire repo can use great defaults and your fellow developers can know what to expect when writing code in the Workspace."
    }), "\n", _jsxs(_components.p, {
      children: ["TypeScript 的 ", _jsx(_components.code, {
        children: "tsconfig.json"
      }), " 设置了 TypeScript 编译器的配置，并提供了一个 ", _jsxs(_components.a, {
        href: "https://ts.nodejs.cn/tsconfig#extends",
        children: [_jsx(_components.code, {
          children: "extends"
        }), " 键"]
      }), "，你可以使用它在整个工作区中共享配置。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥TypeScript's ", _jsx(_components.code, {
        children: "tsconfig.json"
      }), " sets the configuration for the TypeScript compiler and features an ", _jsxs(_components.a, {
        href: "https://ts.nodejs.cn/tsconfig#extends",
        children: [_jsx(_components.code, {
          children: "extends"
        }), " key"]
      }), " that you'll use to share configuration across your workspace."]
    }), "\n", _jsxs(_components.p, {
      children: ["本指南将以 ", _jsx(_components.a, {
        href: "/docs/reference/create-turbo",
        children: _jsx(_components.code, {
          children: "create-turbo"
        })
      }), " 为例。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥This guide will use ", _jsx(_components.a, {
        href: "/docs/reference/create-turbo",
        children: _jsx(_components.code, {
          children: "create-turbo"
        })
      }), " as an example."]
    }), "\n", _jsxs(Tabs, {
      groupId: "package-manager",
      items: ['pnpm', 'yarn', 'npm', 'bun'],
      persist: true,
      children: [_jsx(Tab, {
        value: "pnpm",
        children: _jsx(_Fragment, {
          children: _jsx(_components.pre, {
            className: "shiki shiki-themes css-variables css-variables",
            style: {
              "--shiki-light": "var(--shiki-foreground)",
              "--shiki-dark": "var(--shiki-foreground)",
              "--shiki-light-bg": "var(--shiki-background)",
              "--shiki-dark-bg": "var(--shiki-background)"
            },
            tabIndex: "0",
            title: "Terminal",
            icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
            children: _jsx(_components.code, {
              children: _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-function)",
                    "--shiki-dark": "var(--shiki-token-function)"
                  },
                  children: "pnpm"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " dlx"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " create-turbo@latest"
                })]
              })
            })
          })
        })
      }), _jsx(Tab, {
        value: "yarn",
        children: _jsx(_Fragment, {
          children: _jsx(_components.pre, {
            className: "shiki shiki-themes css-variables css-variables",
            style: {
              "--shiki-light": "var(--shiki-foreground)",
              "--shiki-dark": "var(--shiki-foreground)",
              "--shiki-light-bg": "var(--shiki-background)",
              "--shiki-dark-bg": "var(--shiki-background)"
            },
            tabIndex: "0",
            title: "Terminal",
            icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
            children: _jsx(_components.code, {
              children: _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-function)",
                    "--shiki-dark": "var(--shiki-token-function)"
                  },
                  children: "yarn"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " dlx"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " create-turbo@latest"
                })]
              })
            })
          })
        })
      }), _jsx(Tab, {
        value: "npm",
        children: _jsx(_Fragment, {
          children: _jsx(_components.pre, {
            className: "shiki shiki-themes css-variables css-variables",
            style: {
              "--shiki-light": "var(--shiki-foreground)",
              "--shiki-dark": "var(--shiki-foreground)",
              "--shiki-light-bg": "var(--shiki-background)",
              "--shiki-dark-bg": "var(--shiki-background)"
            },
            tabIndex: "0",
            title: "Terminal",
            icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
            children: _jsx(_components.code, {
              children: _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-function)",
                    "--shiki-dark": "var(--shiki-token-function)"
                  },
                  children: "npx"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " create-turbo@latest"
                })]
              })
            })
          })
        })
      }), _jsx(Tab, {
        value: "bun",
        children: _jsx(_Fragment, {
          children: _jsx(_components.pre, {
            className: "shiki shiki-themes css-variables css-variables",
            style: {
              "--shiki-light": "var(--shiki-foreground)",
              "--shiki-dark": "var(--shiki-foreground)",
              "--shiki-light-bg": "var(--shiki-background)",
              "--shiki-dark-bg": "var(--shiki-background)"
            },
            tabIndex: "0",
            title: "Terminal",
            icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
            children: _jsx(_components.code, {
              children: _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-function)",
                    "--shiki-dark": "var(--shiki-token-function)"
                  },
                  children: "bunx"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " create-turbo@latest"
                })]
              })
            })
          })
        })
      })]
    }), "\n", _jsxs(_components.h3, {
      id: "使用基础-tsconfig-文件-use-a-base-tsconfig-file",
      children: ["使用基础 ", _jsx(_components.code, {
        children: "tsconfig"
      }), " 文件 "]
    }), "\n", _jsxs(_components.p, {
      children: ["¥Use a base ", _jsx(_components.code, {
        children: "tsconfig"
      }), " file"]
    }), "\n", _jsxs(_components.p, {
      children: ["在 ", _jsx(_components.code, {
        children: "packages/typescript-config"
      }), " 文件中，有几个 ", _jsx(_components.code, {
        children: "json"
      }), " 文件，它们代表了你可能希望在各个包中配置 TypeScript 的不同方式。", _jsx(_components.code, {
        children: "base.json"
      }), " 文件由工作区中的所有其他 ", _jsx(_components.code, {
        children: "tsconfig.json"
      }), " 文件扩展，如下所示："]
    }), "\n", _jsxs(_components.p, {
      children: ["¥Inside ", _jsx(_components.code, {
        children: "packages/typescript-config"
      }), ", you have a few ", _jsx(_components.code, {
        children: "json"
      }), " files which represent different ways you might want to configure TypeScript in various packages. The ", _jsx(_components.code, {
        children: "base.json"
      }), " file is extended by every other ", _jsx(_components.code, {
        children: "tsconfig.json"
      }), " in the workspace and looks like this:"]
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "./packages/typescript-config/base.json",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
        children: _jsxs(_components.code, {
          children: [_jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "{"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "  \"compilerOptions\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "    \"esModuleInterop\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-constant)",
                "--shiki-dark": "var(--shiki-token-constant)"
              },
              children: " true"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "    \"skipLibCheck\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-constant)",
                "--shiki-dark": "var(--shiki-token-constant)"
              },
              children: " true"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "    \"target\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: " \"es2022\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "    \"allowJs\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-constant)",
                "--shiki-dark": "var(--shiki-token-constant)"
              },
              children: " true"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "    \"resolveJsonModule\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-constant)",
                "--shiki-dark": "var(--shiki-token-constant)"
              },
              children: " true"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "    \"moduleDetection\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: " \"force\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "    \"isolatedModules\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-constant)",
                "--shiki-dark": "var(--shiki-token-constant)"
              },
              children: " true"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "    \"strict\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-constant)",
                "--shiki-dark": "var(--shiki-token-constant)"
              },
              children: " true"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "    \"noUncheckedIndexedAccess\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-constant)",
                "--shiki-dark": "var(--shiki-token-constant)"
              },
              children: " true"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "    \"module\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: " \"NodeNext\""
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "  }"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "}"
            })
          })]
        })
      })
    }), "\n", _jsxs(LinkToDocumentation, {
      href: "https://ts.nodejs.cn/tsconfig",
      children: [_jsxs(_components.p, {
        children: [_jsx(_components.code, {
          children: "tsconfig"
        }), " 选项参考"]
      }), _jsxs(_components.p, {
        children: ["¥", _jsx(_components.code, {
          children: "tsconfig"
        }), " options reference"]
      })]
    }), "\n", _jsx(_components.h3, {
      id: "创建其余部分包-creating-the-rest-of-the-package",
      children: "创建其余部分包 "
    }), "\n", _jsx(_components.p, {
      children: "¥Creating the rest of the package"
    }), "\n", _jsxs(_components.p, {
      children: ["此包中的其他 ", _jsx(_components.code, {
        children: "tsconfig"
      }), " 文件使用 ", _jsx(_components.code, {
        children: "extends"
      }), " 键，以基本配置启动，并针对特定类型的项目进行自定义，例如 Next.js (", _jsx(_components.code, {
        children: "nextjs.json"
      }), ") 和 React 库 (", _jsx(_components.code, {
        children: "react-library.json"
      }), ")。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥The other ", _jsx(_components.code, {
        children: "tsconfig"
      }), " files in this package use the ", _jsx(_components.code, {
        children: "extends"
      }), " key to start with the base configuration and customize for specific types of projects, like for Next.js (", _jsx(_components.code, {
        children: "nextjs.json"
      }), ") and a React library (", _jsx(_components.code, {
        children: "react-library.json"
      }), ")."]
    }), "\n", _jsxs(_components.p, {
      children: ["在 ", _jsx(_components.code, {
        children: "package.json"
      }), " 文件中，为包命名，以便可以在工作区的其余部分引用它："]
    }), "\n", _jsxs(_components.p, {
      children: ["¥Inside ", _jsx(_components.code, {
        children: "package.json"
      }), ", name the package so it can be referenced in the rest of the Workspace:"]
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "packages/typescript-config/package.json",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
        children: _jsxs(_components.code, {
          children: [_jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "{"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "  \"name\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: " \"@repo/typescript-config\""
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "}"
            })
          })]
        })
      })
    }), "\n", _jsx(_components.h2, {
      id: "构建-typescript-软件包-building-a-typescript-package",
      children: "构建 TypeScript 软件包 "
    }), "\n", _jsx(_components.p, {
      children: "¥Building a TypeScript package"
    }), "\n", _jsx(_components.h3, {
      id: "使用配置包-using-the-configuration-package",
      children: "使用配置包 "
    }), "\n", _jsx(_components.p, {
      children: "¥Using the configuration package"
    }), "\n", _jsxs(_components.p, {
      children: ["首先，将 ", _jsx(_components.code, {
        children: "@repo/typescript-config"
      }), " 包安装到你的包中："]
    }), "\n", _jsxs(_components.p, {
      children: ["¥First, install the ", _jsx(_components.code, {
        children: "@repo/typescript-config"
      }), " package into your package:"]
    }), "\n", _jsxs(Tabs, {
      groupId: "package-manager",
      items: ['pnpm', 'yarn', 'npm', 'bun'],
      persist: true,
      children: [_jsx(Tab, {
        value: "pnpm",
        children: _jsx(_Fragment, {
          children: _jsx(_components.pre, {
            className: "shiki shiki-themes css-variables css-variables",
            style: {
              "--shiki-light": "var(--shiki-foreground)",
              "--shiki-dark": "var(--shiki-foreground)",
              "--shiki-light-bg": "var(--shiki-background)",
              "--shiki-dark-bg": "var(--shiki-background)"
            },
            tabIndex: "0",
            title: "./apps/web/package.json",
            icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
            children: _jsxs(_components.code, {
              children: [_jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "{"
                })
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "  \"devDependencies\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: " {"
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "     \"@repo/typescript-config\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string-expression)",
                    "--shiki-dark": "var(--shiki-token-string-expression)"
                  },
                  children: " \"workspace:*\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ","
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "     \"typescript\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string-expression)",
                    "--shiki-dark": "var(--shiki-token-string-expression)"
                  },
                  children: " \"latest\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ","
                })]
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "  }"
                })
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "}"
                })
              })]
            })
          })
        })
      }), _jsx(Tab, {
        value: "yarn",
        children: _jsx(_Fragment, {
          children: _jsx(_components.pre, {
            className: "shiki shiki-themes css-variables css-variables",
            style: {
              "--shiki-light": "var(--shiki-foreground)",
              "--shiki-dark": "var(--shiki-foreground)",
              "--shiki-light-bg": "var(--shiki-background)",
              "--shiki-dark-bg": "var(--shiki-background)"
            },
            tabIndex: "0",
            title: "./apps/web/package.json",
            icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
            children: _jsxs(_components.code, {
              children: [_jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "{"
                })
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "  \"devDependencies\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: " {"
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "     \"@repo/typescript-config\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string-expression)",
                    "--shiki-dark": "var(--shiki-token-string-expression)"
                  },
                  children: " \"*\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ","
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "     \"typescript\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string-expression)",
                    "--shiki-dark": "var(--shiki-token-string-expression)"
                  },
                  children: " \"latest\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ","
                })]
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "  }"
                })
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "}"
                })
              })]
            })
          })
        })
      }), _jsx(Tab, {
        value: "npm",
        children: _jsx(_Fragment, {
          children: _jsx(_components.pre, {
            className: "shiki shiki-themes css-variables css-variables",
            style: {
              "--shiki-light": "var(--shiki-foreground)",
              "--shiki-dark": "var(--shiki-foreground)",
              "--shiki-light-bg": "var(--shiki-background)",
              "--shiki-dark-bg": "var(--shiki-background)"
            },
            tabIndex: "0",
            title: "./apps/web/package.json",
            icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
            children: _jsxs(_components.code, {
              children: [_jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "{"
                })
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "  \"devDependencies\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: " {"
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "     \"@repo/typescript-config\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string-expression)",
                    "--shiki-dark": "var(--shiki-token-string-expression)"
                  },
                  children: " \"*\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ","
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "     \"typescript\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string-expression)",
                    "--shiki-dark": "var(--shiki-token-string-expression)"
                  },
                  children: " \"latest\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ","
                })]
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "  }"
                })
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "}"
                })
              })]
            })
          })
        })
      }), _jsx(Tab, {
        value: "bun",
        children: _jsx(_Fragment, {
          children: _jsx(_components.pre, {
            className: "shiki shiki-themes css-variables css-variables",
            style: {
              "--shiki-light": "var(--shiki-foreground)",
              "--shiki-dark": "var(--shiki-foreground)",
              "--shiki-light-bg": "var(--shiki-background)",
              "--shiki-dark-bg": "var(--shiki-background)"
            },
            tabIndex: "0",
            title: "./apps/web/package.json",
            icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
            children: _jsxs(_components.code, {
              children: [_jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "{"
                })
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "  \"devDependencies\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: " {"
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "     \"@repo/typescript-config\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string-expression)",
                    "--shiki-dark": "var(--shiki-token-string-expression)"
                  },
                  children: " \"workspace:*\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ","
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "     \"typescript\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string-expression)",
                    "--shiki-dark": "var(--shiki-token-string-expression)"
                  },
                  children: " \"latest\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ","
                })]
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "  }"
                })
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "}"
                })
              })]
            })
          })
        })
      })]
    }), "\n", _jsxs(_components.p, {
      children: ["然后，从 ", _jsx(_components.code, {
        children: "@repo/typescript-config"
      }), " 包中扩展包的 ", _jsx(_components.code, {
        children: "tsconfig.json"
      }), "。在此示例中，", _jsx(_components.code, {
        children: "web"
      }), " 包是一个 Next.js 应用："]
    }), "\n", _jsxs(_components.p, {
      children: ["¥Then, extend the ", _jsx(_components.code, {
        children: "tsconfig.json"
      }), " for the package from the ", _jsx(_components.code, {
        children: "@repo/typescript-config"
      }), " package. In this example, the ", _jsx(_components.code, {
        children: "web"
      }), " package is a Next.js application:"]
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "./apps/web/tsconfig.json",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
        children: _jsxs(_components.code, {
          children: [_jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "{"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "  \"extends\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: " \"@repo/typescript-config/nextjs.json\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "  \"compilerOptions\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "    \"outDir\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: " \"dist\""
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "  }"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "  \"include\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " ["
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: "\"src\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "]"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "  \"exclude\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " ["
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: "\"node_modules\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "]"
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "}"
            })
          })]
        })
      })
    }), "\n", _jsx(_components.h3, {
      id: "创建包的入口点-creating-entrypoints-to-the-package",
      children: "创建包的入口点 "
    }), "\n", _jsx(_components.p, {
      children: "¥Creating entrypoints to the package"
    }), "\n", _jsxs(_components.p, {
      children: ["首先，确保你的代码使用 ", _jsx(_components.code, {
        children: "tsc"
      }), " 编译，这样就会有一个 ", _jsx(_components.code, {
        children: "dist"
      }), " 目录。你需要一个 ", _jsx(_components.code, {
        children: "build"
      }), " 脚本和一个 ", _jsx(_components.code, {
        children: "dev"
      }), " 脚本："]
    }), "\n", _jsxs(_components.p, {
      children: ["¥First, make sure your code gets compiled with ", _jsx(_components.code, {
        children: "tsc"
      }), " so there will be a ", _jsx(_components.code, {
        children: "dist"
      }), " directory. You'll need a ", _jsx(_components.code, {
        children: "build"
      }), " script as well as a ", _jsx(_components.code, {
        children: "dev"
      }), " script:"]
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "./packages/ui/package.json",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
        children: _jsxs(_components.code, {
          children: [_jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "{"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "  \"scripts\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "    \"dev\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: " \"tsc --watch\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "    \"build\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: " \"tsc\""
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "  }"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "}"
            })
          })]
        })
      })
    }), "\n", _jsxs(_components.p, {
      children: ["然后，在 ", _jsx(_components.code, {
        children: "package.json"
      }), " 中为你的包设置入口点，以便其他包可以使用编译后的代码："]
    }), "\n", _jsxs(_components.p, {
      children: ["¥Then, set up the entrypoints for your package in ", _jsx(_components.code, {
        children: "package.json"
      }), " so that other packages can use the compiled code:"]
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "./packages/ui/package.json",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
        children: _jsxs(_components.code, {
          children: [_jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "{"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "  \"exports\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "    \"./*\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "      \"types\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: " \"./src/*.ts\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "      \"default\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: " \"./dist/*.js\""
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "    }"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "  }"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "}"
            })
          })]
        })
      })
    }), "\n", _jsxs(_components.p, {
      children: ["以这种方式设置 ", _jsx(_components.code, {
        children: "exports"
      }), " 有几个优点："]
    }), "\n", _jsxs(_components.p, {
      children: ["¥Setting up ", _jsx(_components.code, {
        children: "exports"
      }), " this way has several advantages:"]
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: ["\n", _jsxs(_components.p, {
          children: ["使用 ", _jsx(_components.code, {
            children: "types"
          }), " 字段允许 ", _jsx(_components.code, {
            children: "tsserver"
          }), " 使用 ", _jsx(_components.code, {
            children: "src"
          }), " 中的代码作为代码类型的真实来源。你的编辑器将始终使用你代码中的最新接口保持更新。"]
        }), "\n", _jsxs(_components.p, {
          children: ["¥Using the ", _jsx(_components.code, {
            children: "types"
          }), " field allows ", _jsx(_components.code, {
            children: "tsserver"
          }), " to use the code in ", _jsx(_components.code, {
            children: "src"
          }), " as the source of truth for your code's types. Your editor will always be up-to-date with the latest interfaces from your code."]
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsxs(_components.p, {
          children: ["你可以快速向包中添加新的入口点，而无需创建 ", _jsx(_components.a, {
            href: "https://vercel.com/blog/how-we-optimized-package-imports-in-next-js#what's-the-problem-with-barrel-files",
            children: "危险的桶文件"
          }), "。"]
        }), "\n", _jsxs(_components.p, {
          children: ["¥You can quickly add new entrypoints to your package without creating ", _jsx(_components.a, {
            href: "https://vercel.com/blog/how-we-optimized-package-imports-in-next-js#what's-the-problem-with-barrel-files",
            children: "dangerous barrel files"
          }), "."]
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: "你将在编辑器中收到跨包导入的自动导入建议。"
        }), "\n", _jsx(_components.p, {
          children: "¥You'll receive auto-importing suggestions for your imports across package boundaries in your editor."
        }), "\n"]
      }), "\n"]
    }), "\n", _jsxs(Callout, {
      type: "warn",
      children: [_jsxs(_components.p, {
        children: ["如果你要发布软件包，则无法在 ", _jsx(_components.code, {
          children: "types"
        }), " 中使用对源代码的引用，因为只有编译后的代码才会发布到 npm。你需要生成并引用声明文件和源映射。"]
      }), _jsxs(_components.p, {
        children: ["¥If you're publishing the package, you cannot use references to source code in\n", _jsx(_components.code, {
          children: "types"
        }), " since only the compiled code will be published to npm. You'll need to\ngenerate and reference declaration files and source maps."]
      })]
    }), "\n", _jsx(_components.h2, {
      id: "代码库的-linting-linting-your-codebase",
      children: "代码库的 Linting "
    }), "\n", _jsx(_components.p, {
      children: "¥Linting your codebase"
    }), "\n", _jsx(_components.p, {
      children: "要将 TypeScript 用作 linter，你可以使用 Turborepo 的缓存和并行化功能快速检查整个工作区的类型。"
    }), "\n", _jsxs(_components.p, {
      children: ["¥To use TypeScript as a linter, you can check the types across your workspace ", _jsx(_components.strong, {
        children: "fast"
      }), " using Turborepo's caching and parallelization."]
    }), "\n", _jsxs(_components.p, {
      children: ["首先，向任何你想要检查类型的包添加一个 ", _jsx(_components.code, {
        children: "check-types"
      }), " 脚本："]
    }), "\n", _jsxs(_components.p, {
      children: ["¥First, add a ", _jsx(_components.code, {
        children: "check-types"
      }), " script to any package that you want to check the types for:"]
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "./apps/web/package.json",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
        children: _jsxs(_components.code, {
          children: [_jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "{"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "  \"scripts\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "    \"check-types\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: " \"tsc --noEmit\""
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "  }"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "}"
            })
          })]
        })
      })
    }), "\n", _jsxs(_components.p, {
      children: ["然后，在 ", _jsx(_components.code, {
        children: "turbo.json"
      }), " 中创建一个 ", _jsx(_components.code, {
        children: "check-types"
      }), " 任务。从 ", _jsx(_components.a, {
        href: "/docs/crafting-your-repository/configuring-tasks#dependent-tasks-that-can-be-run-in-parallel",
        children: "配置任务指南"
      }), " 开始，我们可以使用 ", _jsx(_components.a, {
        href: "/docs/core-concepts/package-and-task-graph#transit-nodes",
        children: "Transit Node"
      }), " 使任务并行运行，同时尊重其他软件包的源代码更改："]
    }), "\n", _jsxs(_components.p, {
      children: ["¥Then, create a ", _jsx(_components.code, {
        children: "check-types"
      }), " task in ", _jsx(_components.code, {
        children: "turbo.json"
      }), ". From the ", _jsx(_components.a, {
        href: "/docs/crafting-your-repository/configuring-tasks#dependent-tasks-that-can-be-run-in-parallel",
        children: "Configuring tasks guide"
      }), ", we can make the task run in parallel while respecting source code changes from other packages using a ", _jsx(_components.a, {
        href: "/docs/core-concepts/package-and-task-graph#transit-nodes",
        children: "Transit Node"
      }), ":"]
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "./turbo.json",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
        children: _jsxs(_components.code, {
          children: [_jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "{"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "  \"tasks\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "    \"topo\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "      \"dependsOn\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " ["
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: "\"^topo\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "]"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "    }"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "    \"check-types\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "      \"dependsOn\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " ["
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: "\"topo\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "]"
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "    }"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "  }"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "}"
            })
          })]
        })
      })
    }), "\n", _jsxs(_components.p, {
      children: ["然后，使用 ", _jsx(_components.code, {
        children: "turbo check-types"
      }), " 运行你的任务。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥Then, run your task using ", _jsx(_components.code, {
        children: "turbo check-types"
      }), "."]
    }), "\n", _jsx(_components.h2, {
      id: "最佳实践-best-practices",
      children: "最佳实践 "
    }), "\n", _jsx(_components.p, {
      children: "¥Best practices"
    }), "\n", _jsxs(_components.h3, {
      id: "使用-tsc-编译你的软件包-use-tsc-to-compile-your-packages",
      children: ["使用 ", _jsx(_components.code, {
        children: "tsc"
      }), " 编译你的软件包 "]
    }), "\n", _jsxs(_components.p, {
      children: ["¥Use ", _jsx(_components.code, {
        children: "tsc"
      }), " to compile your packages"]
    }), "\n", _jsxs(_components.p, {
      children: ["对于 ", _jsx(_components.a, {
        href: "/docs/core-concepts/internal-packages",
        children: "内部软件包"
      }), "，我们建议你尽可能使用 ", _jsx(_components.code, {
        children: "tsc"
      }), " 来编译 TypeScript 库。虽然你可以使用打包器，但它不是必需的，而且会增加构建过程的复杂性。此外，打包库可能会在代码到达应用的打包器之前对其进行破坏，从而导致难以调试的问题。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥For ", _jsx(_components.a, {
        href: "/docs/core-concepts/internal-packages",
        children: "Internal Packages"
      }), ", we recommend that you use ", _jsx(_components.code, {
        children: "tsc"
      }), " to compile your TypeScript libraries whenever possible. While you can use a bundler, it's not necessary and adds extra complexity to your build process. Additionally, bundling a library can mangle the code before it makes it to your applications' bundlers, causing hard to debug issues."]
    }), "\n", _jsx(_components.h3, {
      id: "启用跨包边界的跳转定义-enable-go-to-definition-across-package-boundaries",
      children: "启用跨包边界的跳转定义 "
    }), "\n", _jsx(_components.p, {
      children: "¥Enable go-to-definition across package boundaries"
    }), "\n", _jsxs(_components.p, {
      children: ["\"跳转至定义\" 是一项编辑器功能，可通过单击或热键快速导航到符号（如变量或函数）的原始声明或定义。正确配置 TypeScript 后，你可以轻松在 ", _jsx(_components.a, {
        href: "/docs/core-concepts/internal-packages",
        children: "内部软件包"
      }), " 中导航。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥\"Go-to-definition\" is an editor feature for quickly navigating to the original declaration or definition of a symbol (like a variable or function) with a click or hotkey. Once TypeScript is configured correctly, you can navigate across ", _jsx(_components.a, {
        href: "/docs/core-concepts/internal-packages",
        children: "Internal Packages"
      }), " with ease."]
    }), "\n", _jsx(_components.h4, {
      id: "即时软件包-just-in-time-packages",
      children: "即时软件包 "
    }), "\n", _jsx(_components.p, {
      children: "¥Just-in-Time Packages"
    }), "\n", _jsxs(_components.p, {
      children: ["从 ", _jsx(_components.a, {
        href: "/docs/core-concepts/internal-packages#just-in-time-packages",
        children: "即时软件包"
      }), " 导出将自动转到原始 TypeScript 源代码。跳转定义功能将按预期工作。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥Exports from ", _jsx(_components.a, {
        href: "/docs/core-concepts/internal-packages#just-in-time-packages",
        children: "Just-in-Time Packages"
      }), " will automatically bring you to the original TypeScript source code. Go-to-definition will work as expected."]
    }), "\n", _jsx(_components.h4, {
      id: "已编译的软件包-compiled-packages",
      children: "已编译的软件包 "
    }), "\n", _jsx(_components.p, {
      children: "¥Compiled Packages"
    }), "\n", _jsxs(_components.p, {
      children: ["从 ", _jsx(_components.a, {
        href: "/docs/core-concepts/internal-packages#compiled-packages",
        children: "已编译的软件包"
      }), " 导出需要使用 ", _jsx(_components.a, {
        href: "https://ts.nodejs.cn/tsconfig/#declaration",
        children: _jsx(_components.code, {
          children: "declaration"
        })
      }), " 和 ", _jsx(_components.a, {
        href: "https://ts.nodejs.cn/tsconfig/#declarationMap",
        children: _jsx(_components.code, {
          children: "declarationMap"
        })
      }), " 配置才能实现跳转定义功能。为包启用这两个配置后，使用 ", _jsx(_components.code, {
        children: "tsc"
      }), " 编译包，然后打开输出目录以查找声明文件和源映射。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥Exports from ", _jsx(_components.a, {
        href: "/docs/core-concepts/internal-packages#compiled-packages",
        children: "Compiled Packages"
      }), " require the use of ", _jsx(_components.a, {
        href: "https://ts.nodejs.cn/tsconfig/#declaration",
        children: _jsx(_components.code, {
          children: "declaration"
        })
      }), " and ", _jsx(_components.a, {
        href: "https://ts.nodejs.cn/tsconfig/#declarationMap",
        children: _jsx(_components.code, {
          children: "declarationMap"
        })
      }), " configurations for go-to-definition to work. After you've enabled these two configurations for the package, compile the package with ", _jsx(_components.code, {
        children: "tsc"
      }), ", and open the output directory to find declaration files and source maps."]
    }), "\n", _jsx(Files, {
      children: _jsx(Folder, {
        defaultOpen: true,
        name: "packages",
        children: _jsx(Folder, {
          defaultOpen: true,
          name: "ui",
          children: _jsxs(Folder, {
            defaultOpen: true,
            name: "dist",
            children: [_jsx(File, {
              name: "button.js"
            }), _jsx(File, {
              name: "button.d.ts",
              green: true
            }), _jsx(File, {
              name: "button.d.ts.map",
              green: true
            })]
          })
        })
      })
    }), "\n", _jsx(_components.p, {
      children: "有了这两个文件，你的编辑器现在将导航到原始源代码。"
    }), "\n", _jsx(_components.p, {
      children: "¥With these two files in place, your editor will now navigate to the original source code."
    }), "\n", _jsxs(_components.h3, {
      id: "使用-nodejs-子路径导入而不是-typescript-编译器-paths-use-nodejs-subpath-imports-instead-of-typescript-compiler-paths",
      children: ["使用 Node.js 子路径导入，而不是 TypeScript 编译器 ", _jsx(_components.code, {
        children: "paths"
      }), " "]
    }), "\n", _jsxs(_components.p, {
      children: ["¥Use Node.js subpath imports instead of TypeScript compiler ", _jsx(_components.code, {
        children: "paths"
      })]
    }), "\n", _jsxs(_components.p, {
      children: ["可以使用 ", _jsxs(_components.a, {
        href: "https://ts.nodejs.cn/tsconfig#paths",
        children: ["TypeScript 编译器的 ", _jsx(_components.code, {
          children: "paths"
        }), " 选项"]
      }), " 在包中创建绝对导入，但使用 ", _jsx(_components.a, {
        href: "https://turbo.nodejs.cn/docs/core-concepts/internal-packages#just-in-time-packages",
        children: "即时软件包"
      }), " 时，这些路径可能会导致编译失败。", _jsx(_components.a, {
        href: "https://devblogs.microsoft.com/typescript/announcing-typescript-5-4/#auto-import-support-for-subpath-imports",
        children: "自 TypeScript 5.4 起"
      }), "，你可以使用 ", _jsx(_components.a, {
        href: "https://nodejs.cn/api/packages.html#imports",
        children: "Node.js 子路径导入"
      }), " 来获得更强大的解决方案。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥It's possible to create absolute imports in your packages using ", _jsxs(_components.a, {
        href: "https://ts.nodejs.cn/tsconfig#paths",
        children: ["the TypeScript compiler's ", _jsx(_components.code, {
          children: "paths"
        }), " option"]
      }), ", but these paths can cause failed compilation when using ", _jsx(_components.a, {
        href: "https://turbo.nodejs.cn/docs/core-concepts/internal-packages#just-in-time-packages",
        children: "Just-in-Time Packages"
      }), ". ", _jsx(_components.a, {
        href: "https://devblogs.microsoft.com/typescript/announcing-typescript-5-4/#auto-import-support-for-subpath-imports",
        children: "As of TypeScript 5.4"
      }), ", you can use ", _jsx(_components.a, {
        href: "https://nodejs.cn/api/packages.html#imports",
        children: "Node.js subpath imports"
      }), " instead for a more robust solution."]
    }), "\n", _jsx(_components.h4, {
      id: "即时软件包-just-in-time-packages-1",
      children: "即时软件包 "
    }), "\n", _jsx(_components.p, {
      children: "¥Just-in-Time Packages"
    }), "\n", _jsxs(_components.p, {
      children: ["在 ", _jsx(_components.a, {
        href: "https://turbo.nodejs.cn/docs/core-concepts/internal-packages#just-in-time-packages",
        children: "Just-in-Time 包"
      }), " 中，", _jsx(_components.code, {
        children: "imports"
      }), " 必须以包中的源代码为目标，因为不会创建像 ", _jsx(_components.code, {
        children: "dist"
      }), " 这样的构建输出。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥In ", _jsx(_components.a, {
        href: "https://turbo.nodejs.cn/docs/core-concepts/internal-packages#just-in-time-packages",
        children: "Just-in-Time packages"
      }), ", ", _jsx(_components.code, {
        children: "imports"
      }), " must target the source code in the package, since build outputs like ", _jsx(_components.code, {
        children: "dist"
      }), " won't be created."]
    }), "\n", _jsxs(Tabs, {
      storageKey: "ts-imports-jit",
      items: ["package.json", "Source code"],
      children: [_jsx(Tab, {
        value: "package.json",
        children: _jsx(_Fragment, {
          children: _jsx(_components.pre, {
            className: "shiki shiki-themes css-variables css-variables",
            style: {
              "--shiki-light": "var(--shiki-foreground)",
              "--shiki-dark": "var(--shiki-foreground)",
              "--shiki-light-bg": "var(--shiki-background)",
              "--shiki-dark-bg": "var(--shiki-background)"
            },
            tabIndex: "0",
            title: "./packages/ui/package.json",
            icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
            children: _jsxs(_components.code, {
              children: [_jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "{"
                })
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "  \"imports\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: " {"
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "    \"#*\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string-expression)",
                    "--shiki-dark": "var(--shiki-token-string-expression)"
                  },
                  children: " \"./src/*\""
                })]
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "  }"
                })
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "}"
                })
              })]
            })
          })
        })
      }), _jsx(Tab, {
        value: "Source code",
        children: _jsx(_Fragment, {
          children: _jsx(_components.pre, {
            className: "shiki shiki-themes css-variables css-variables has-highlighted",
            style: {
              "--shiki-light": "var(--shiki-foreground)",
              "--shiki-dark": "var(--shiki-foreground)",
              "--shiki-light-bg": "var(--shiki-background)",
              "--shiki-dark-bg": "var(--shiki-background)"
            },
            tabIndex: "0",
            title: "./packages/ui/button.tsx",
            icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M14.23 12.004a2.236 2.236 0 0 1-2.235 2.236 2.236 2.236 0 0 1-2.236-2.236 2.236 2.236 0 0 1 2.235-2.236 2.236 2.236 0 0 1 2.236 2.236zm2.648-10.69c-1.346 0-3.107.96-4.888 2.622-1.78-1.653-3.542-2.602-4.887-2.602-.41 0-.783.093-1.106.278-1.375.793-1.683 3.264-.973 6.365C1.98 8.917 0 10.42 0 12.004c0 1.59 1.99 3.097 5.043 4.03-.704 3.113-.39 5.588.988 6.38.32.187.69.275 1.102.275 1.345 0 3.107-.96 4.888-2.624 1.78 1.654 3.542 2.603 4.887 2.603.41 0 .783-.09 1.106-.275 1.374-.792 1.683-3.263.973-6.365C22.02 15.096 24 13.59 24 12.004c0-1.59-1.99-3.097-5.043-4.032.704-3.11.39-5.587-.988-6.38-.318-.184-.688-.277-1.092-.278zm-.005 1.09v.006c.225 0 .406.044.558.127.666.382.955 1.835.73 3.704-.054.46-.142.945-.25 1.44-.96-.236-2.006-.417-3.107-.534-.66-.905-1.345-1.727-2.035-2.447 1.592-1.48 3.087-2.292 4.105-2.295zm-9.77.02c1.012 0 2.514.808 4.11 2.28-.686.72-1.37 1.537-2.02 2.442-1.107.117-2.154.298-3.113.538-.112-.49-.195-.964-.254-1.42-.23-1.868.054-3.32.714-3.707.19-.09.4-.127.563-.132zm4.882 3.05c.455.468.91.992 1.36 1.564-.44-.02-.89-.034-1.345-.034-.46 0-.915.01-1.36.034.44-.572.895-1.096 1.345-1.565zM12 8.1c.74 0 1.477.034 2.202.093.406.582.802 1.203 1.183 1.86.372.64.71 1.29 1.018 1.946-.308.655-.646 1.31-1.013 1.95-.38.66-.773 1.288-1.18 1.87-.728.063-1.466.098-2.21.098-.74 0-1.477-.035-2.202-.093-.406-.582-.802-1.204-1.183-1.86-.372-.64-.71-1.29-1.018-1.946.303-.657.646-1.313 1.013-1.954.38-.66.773-1.286 1.18-1.868.728-.064 1.466-.098 2.21-.098zm-3.635.254c-.24.377-.48.763-.704 1.16-.225.39-.435.782-.635 1.174-.265-.656-.49-1.31-.676-1.947.64-.15 1.315-.283 2.015-.386zm7.26 0c.695.103 1.365.23 2.006.387-.18.632-.405 1.282-.66 1.933-.2-.39-.41-.783-.64-1.174-.225-.392-.465-.774-.705-1.146zm3.063.675c.484.15.944.317 1.375.498 1.732.74 2.852 1.708 2.852 2.476-.005.768-1.125 1.74-2.857 2.475-.42.18-.88.342-1.355.493-.28-.958-.646-1.956-1.1-2.98.45-1.017.81-2.01 1.085-2.964zm-13.395.004c.278.96.645 1.957 1.1 2.98-.45 1.017-.812 2.01-1.086 2.964-.484-.15-.944-.318-1.37-.5-1.732-.737-2.852-1.706-2.852-2.474 0-.768 1.12-1.742 2.852-2.476.42-.18.88-.342 1.356-.494zm11.678 4.28c.265.657.49 1.312.676 1.948-.64.157-1.316.29-2.016.39.24-.375.48-.762.705-1.158.225-.39.435-.788.636-1.18zm-9.945.02c.2.392.41.783.64 1.175.23.39.465.772.705 1.143-.695-.102-1.365-.23-2.006-.386.18-.63.406-1.282.66-1.933zM17.92 16.32c.112.493.2.968.254 1.423.23 1.868-.054 3.32-.714 3.708-.147.09-.338.128-.563.128-1.012 0-2.514-.807-4.11-2.28.686-.72 1.37-1.536 2.02-2.44 1.107-.118 2.154-.3 3.113-.54zm-11.83.01c.96.234 2.006.415 3.107.532.66.905 1.345 1.727 2.035 2.446-1.595 1.483-3.092 2.295-4.11 2.295-.22-.005-.406-.05-.553-.132-.666-.38-.955-1.834-.73-3.703.054-.46.142-.944.25-1.438zm4.56.64c.44.02.89.034 1.345.034.46 0 .915-.01 1.36-.034-.44.572-.895 1.095-1.345 1.565-.455-.47-.91-.993-1.36-1.565z\" fill=\"currentColor\" /></svg>",
            children: _jsxs(_components.code, {
              children: [_jsxs(_components.span, {
                className: "line highlighted",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "import"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: " { MY_STRING } "
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "from"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string-expression)",
                    "--shiki-dark": "var(--shiki-token-string-expression)"
                  },
                  children: " \"#utils.ts\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-comment)",
                    "--shiki-dark": "var(--shiki-token-comment)"
                  },
                  children: " // Uses .ts extension"
                })]
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: " "
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "export"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: " const"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-function)",
                    "--shiki-dark": "var(--shiki-token-function)"
                  },
                  children: " Button"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: " ="
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: " () "
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "=>"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: " {"
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "  return"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: " ("
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "    <"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string-expression)",
                    "--shiki-dark": "var(--shiki-token-string-expression)"
                  },
                  children: "button"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: ">{"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-constant)",
                    "--shiki-dark": "var(--shiki-token-constant)"
                  },
                  children: "MY_STRING"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "}</"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string-expression)",
                    "--shiki-dark": "var(--shiki-token-string-expression)"
                  },
                  children: "button"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: ">"
                })]
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "  )"
                })
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "}"
                })
              })]
            })
          })
        })
      })]
    }), "\n", _jsx(_components.h4, {
      id: "已编译的软件包-compiled-packages-1",
      children: "已编译的软件包 "
    }), "\n", _jsx(_components.p, {
      children: "¥Compiled Packages"
    }), "\n", _jsxs(_components.p, {
      children: ["在 ", _jsx(_components.a, {
        href: "https://turbo.nodejs.cn/docs/core-concepts/internal-packages#compiled-packages",
        children: "编译包"
      }), " 中，", _jsx(_components.code, {
        children: "imports"
      }), " 以包的构建输出为目标。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥In ", _jsx(_components.a, {
        href: "https://turbo.nodejs.cn/docs/core-concepts/internal-packages#compiled-packages",
        children: "Compiled packages"
      }), ", ", _jsx(_components.code, {
        children: "imports"
      }), " target the built outputs for the package."]
    }), "\n", _jsxs(Tabs, {
      storageKey: "ts-imports-compiled",
      items: ["package.json", "Source code"],
      children: [_jsx(Tab, {
        value: "package.json",
        children: _jsx(_Fragment, {
          children: _jsx(_components.pre, {
            className: "shiki shiki-themes css-variables css-variables",
            style: {
              "--shiki-light": "var(--shiki-foreground)",
              "--shiki-dark": "var(--shiki-foreground)",
              "--shiki-light-bg": "var(--shiki-background)",
              "--shiki-dark-bg": "var(--shiki-background)"
            },
            tabIndex: "0",
            title: "./packages/ui/package.json",
            icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
            children: _jsxs(_components.code, {
              children: [_jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "{"
                })
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "  \"imports\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: " {"
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "    \"#*\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string-expression)",
                    "--shiki-dark": "var(--shiki-token-string-expression)"
                  },
                  children: " \"./dist/*\""
                })]
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "  }"
                })
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "}"
                })
              })]
            })
          })
        })
      }), _jsx(Tab, {
        value: "Source code",
        children: _jsx(_Fragment, {
          children: _jsx(_components.pre, {
            className: "shiki shiki-themes css-variables css-variables has-highlighted",
            style: {
              "--shiki-light": "var(--shiki-foreground)",
              "--shiki-dark": "var(--shiki-foreground)",
              "--shiki-light-bg": "var(--shiki-background)",
              "--shiki-dark-bg": "var(--shiki-background)"
            },
            tabIndex: "0",
            title: "./packages/ui/button.tsx",
            icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M14.23 12.004a2.236 2.236 0 0 1-2.235 2.236 2.236 2.236 0 0 1-2.236-2.236 2.236 2.236 0 0 1 2.235-2.236 2.236 2.236 0 0 1 2.236 2.236zm2.648-10.69c-1.346 0-3.107.96-4.888 2.622-1.78-1.653-3.542-2.602-4.887-2.602-.41 0-.783.093-1.106.278-1.375.793-1.683 3.264-.973 6.365C1.98 8.917 0 10.42 0 12.004c0 1.59 1.99 3.097 5.043 4.03-.704 3.113-.39 5.588.988 6.38.32.187.69.275 1.102.275 1.345 0 3.107-.96 4.888-2.624 1.78 1.654 3.542 2.603 4.887 2.603.41 0 .783-.09 1.106-.275 1.374-.792 1.683-3.263.973-6.365C22.02 15.096 24 13.59 24 12.004c0-1.59-1.99-3.097-5.043-4.032.704-3.11.39-5.587-.988-6.38-.318-.184-.688-.277-1.092-.278zm-.005 1.09v.006c.225 0 .406.044.558.127.666.382.955 1.835.73 3.704-.054.46-.142.945-.25 1.44-.96-.236-2.006-.417-3.107-.534-.66-.905-1.345-1.727-2.035-2.447 1.592-1.48 3.087-2.292 4.105-2.295zm-9.77.02c1.012 0 2.514.808 4.11 2.28-.686.72-1.37 1.537-2.02 2.442-1.107.117-2.154.298-3.113.538-.112-.49-.195-.964-.254-1.42-.23-1.868.054-3.32.714-3.707.19-.09.4-.127.563-.132zm4.882 3.05c.455.468.91.992 1.36 1.564-.44-.02-.89-.034-1.345-.034-.46 0-.915.01-1.36.034.44-.572.895-1.096 1.345-1.565zM12 8.1c.74 0 1.477.034 2.202.093.406.582.802 1.203 1.183 1.86.372.64.71 1.29 1.018 1.946-.308.655-.646 1.31-1.013 1.95-.38.66-.773 1.288-1.18 1.87-.728.063-1.466.098-2.21.098-.74 0-1.477-.035-2.202-.093-.406-.582-.802-1.204-1.183-1.86-.372-.64-.71-1.29-1.018-1.946.303-.657.646-1.313 1.013-1.954.38-.66.773-1.286 1.18-1.868.728-.064 1.466-.098 2.21-.098zm-3.635.254c-.24.377-.48.763-.704 1.16-.225.39-.435.782-.635 1.174-.265-.656-.49-1.31-.676-1.947.64-.15 1.315-.283 2.015-.386zm7.26 0c.695.103 1.365.23 2.006.387-.18.632-.405 1.282-.66 1.933-.2-.39-.41-.783-.64-1.174-.225-.392-.465-.774-.705-1.146zm3.063.675c.484.15.944.317 1.375.498 1.732.74 2.852 1.708 2.852 2.476-.005.768-1.125 1.74-2.857 2.475-.42.18-.88.342-1.355.493-.28-.958-.646-1.956-1.1-2.98.45-1.017.81-2.01 1.085-2.964zm-13.395.004c.278.96.645 1.957 1.1 2.98-.45 1.017-.812 2.01-1.086 2.964-.484-.15-.944-.318-1.37-.5-1.732-.737-2.852-1.706-2.852-2.474 0-.768 1.12-1.742 2.852-2.476.42-.18.88-.342 1.356-.494zm11.678 4.28c.265.657.49 1.312.676 1.948-.64.157-1.316.29-2.016.39.24-.375.48-.762.705-1.158.225-.39.435-.788.636-1.18zm-9.945.02c.2.392.41.783.64 1.175.23.39.465.772.705 1.143-.695-.102-1.365-.23-2.006-.386.18-.63.406-1.282.66-1.933zM17.92 16.32c.112.493.2.968.254 1.423.23 1.868-.054 3.32-.714 3.708-.147.09-.338.128-.563.128-1.012 0-2.514-.807-4.11-2.28.686-.72 1.37-1.536 2.02-2.44 1.107-.118 2.154-.3 3.113-.54zm-11.83.01c.96.234 2.006.415 3.107.532.66.905 1.345 1.727 2.035 2.446-1.595 1.483-3.092 2.295-4.11 2.295-.22-.005-.406-.05-.553-.132-.666-.38-.955-1.834-.73-3.703.054-.46.142-.944.25-1.438zm4.56.64c.44.02.89.034 1.345.034.46 0 .915-.01 1.36-.034-.44.572-.895 1.095-1.345 1.565-.455-.47-.91-.993-1.36-1.565z\" fill=\"currentColor\" /></svg>",
            children: _jsxs(_components.code, {
              children: [_jsxs(_components.span, {
                className: "line highlighted",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "import"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: " { MY_STRING } "
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "from"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string-expression)",
                    "--shiki-dark": "var(--shiki-token-string-expression)"
                  },
                  children: " '#utils.js'"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "; "
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-comment)",
                    "--shiki-dark": "var(--shiki-token-comment)"
                  },
                  children: "// Uses .js extension"
                })]
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: " "
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "export"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: " const"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-function)",
                    "--shiki-dark": "var(--shiki-token-function)"
                  },
                  children: " Button"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: " ="
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: " () "
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "=>"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: " {"
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "  return"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: " <"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string-expression)",
                    "--shiki-dark": "var(--shiki-token-string-expression)"
                  },
                  children: "button"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: ">{"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-constant)",
                    "--shiki-dark": "var(--shiki-token-constant)"
                  },
                  children: "MY_STRING"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "}</"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string-expression)",
                    "--shiki-dark": "var(--shiki-token-string-expression)"
                  },
                  children: "button"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: ">;"
                })]
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "};"
                })
              })]
            })
          })
        })
      })]
    }), "\n", _jsxs(_components.h3, {
      id: "你可能不需要在项目根目录中放置-tsconfigjson-文件-you-likely-dont-need-a-tsconfigjson-file-in-the-root-of-your-project",
      children: ["你可能不需要在项目根目录中放置 ", _jsx(_components.code, {
        children: "tsconfig.json"
      }), " 文件 "]
    }), "\n", _jsxs(_components.p, {
      children: ["¥You likely don't need a ", _jsx(_components.code, {
        children: "tsconfig.json"
      }), " file in the root of your project"]
    }), "\n", _jsxs(_components.p, {
      children: ["正如 ", _jsx(_components.a, {
        href: "/docs/crafting-your-repository/structuring-a-repository#anatomy-of-a-package",
        children: "构建仓库指南"
      }), " 中提到的，你需要将工具中的每个包视为独立的单元。这意味着每个包都应该有自己的 ", _jsx(_components.code, {
        children: "tsconfig.json"
      }), " 可供使用，而不是在项目根目录中引用 ", _jsx(_components.code, {
        children: "tsconfig.json"
      }), "。遵循此做法将使 Turborepo 更轻松地缓存你的类型检查任务，从而简化你的配置。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥As mentioned in the ", _jsx(_components.a, {
        href: "/docs/crafting-your-repository/structuring-a-repository#anatomy-of-a-package",
        children: "Structuring your repository guide"
      }), ", you want to treat each package in your tooling as its own unit. This means each package should have its own ", _jsx(_components.code, {
        children: "tsconfig.json"
      }), " to use instead of referencing a ", _jsx(_components.code, {
        children: "tsconfig.json"
      }), " in the root of your project. Following this practice will make it easier for Turborepo to cache your type checking tasks, simplifying your configuration."]
    }), "\n", _jsxs(_components.p, {
      children: ["唯一可能需要在工作区根目录中使用 ", _jsx(_components.code, {
        children: "tsconfig.json"
      }), " 的情况是，需要为不在包中的 TypeScript 文件设置配置。例如，如果你有一个用 TypeScript 编写的脚本需要从根目录运行，则该文件可能需要一个 ", _jsx(_components.code, {
        children: "tsconfig.json"
      }), "。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥The only case in which you may want to have a ", _jsx(_components.code, {
        children: "tsconfig.json"
      }), " in the Workspace root is to set configuration for TypeScript files that are not in packages. For example, if you have a script written with TypeScript that you need to run from the root, you may need a ", _jsx(_components.code, {
        children: "tsconfig.json"
      }), " for that file."]
    }), "\n", _jsx(_components.p, {
      children: "但是，我们不建议这样做，因为工作区根目录中的任何更改都会导致所有任务缓存丢失。相反，将这些脚本移动到代码库中的其他目录。"
    }), "\n", _jsx(_components.p, {
      children: "¥However, this practice is also discouraged since any changes in the Workspace root will cause all tasks to miss cache. Instead, move those scripts to a different directory in the repository."
    }), "\n", _jsx(_components.h3, {
      id: "你可能不需要-typescript-项目引用-you-likely-dont-need-typescript-project-references",
      children: "你可能不需要 TypeScript 项目引用 "
    }), "\n", _jsx(_components.p, {
      children: "¥You likely don't need TypeScript Project References"
    }), "\n", _jsx(_components.p, {
      children: "我们不建议使用 TypeScript 项目引用，因为它们会为你的工作区引入另一个配置点和另一个缓存层。这两种方式都可能在你的仓库中造成问题，而且几乎没有什么好处，所以我们建议在使用 Turborepo 时避免使用它们。"
    }), "\n", _jsx(_components.p, {
      children: "¥We don't recommend using TypeScript Project References as they introduce both another point of configuration as well as another caching layer to your workspace. Both of these can cause problems in your repository with little benefit, so we suggest avoiding them when using Turborepo."
    }), "\n", _jsx(_components.h2, {
      id: "限制-limitations",
      children: "限制 "
    }), "\n", _jsx(_components.p, {
      children: "¥Limitations"
    }), "\n", _jsx(_components.h3, {
      id: "你的编辑器不会使用包的-typescript-版本-your-editor-wont-use-a-packages-typescript-version",
      children: "你的编辑器不会使用包的 TypeScript 版本 "
    }), "\n", _jsx(_components.p, {
      children: "¥Your editor won't use a package's TypeScript version"
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.code, {
        children: "tsserver"
      }), " 无法在你的代码编辑器中为不同的包使用不同的 TypeScript 版本。相反，它会发现一个特定的版本并在任何地方使用它。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥", _jsx(_components.code, {
        children: "tsserver"
      }), " is not able to use different TypeScript versions for different packages in your code editor. Instead, it will discover a specific version and use that everywhere."]
    }), "\n", _jsxs(_components.p, {
      children: ["这可能会导致编辑器中显示的 linting 错误与你运行 ", _jsx(_components.code, {
        children: "tsc"
      }), " 脚本检查类型时显示的 linting 错误不同。如果这对你来说是一个问题，请考虑使用 ", _jsx(_components.a, {
        href: "/docs/crafting-your-repository/managing-dependencies#keeping-dependencies-on-the-same-version",
        children: "保持 TypeScript 依赖在同一版本上"
      }), "。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥This can result in differences between the linting errors that show in your editor and when you run ", _jsx(_components.code, {
        children: "tsc"
      }), " scripts to check types. If this is an issue for you, consider ", _jsx(_components.a, {
        href: "/docs/crafting-your-repository/managing-dependencies#keeping-dependencies-on-the-same-version",
        children: "keeping the TypeScript dependency on the same version"
      }), "."]
    })]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = props.components || ({});
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}
